import type {
  PushSubscriptionLike,
  PushAPISubscription,
} from '../types/push-api.types';

function arrayBufferToString(buffer: Uint8Array): string {
  const bufferLength = buffer.length;
  const result: string[] = [];

  for (let i = 0; i < bufferLength; i++) {
    result.push(String.fromCharCode(buffer[i]));
  }

  return btoa(result.join(''));
}

/**
 * Украдено отсюда, чтобы можно было сравнивать ключ из конфига с ключом сущетсвующй подписки
 * [https://github.com/firebase/firebase-js-sdk/blob/5ad7ff2ae955c297556223e6cb3ad9d4b897f664/packages/
 * messaging/src/helpers/array-base64-translator.ts#L18](вот отсюда)
 */
function arrayToBase64(array?: Uint8Array | ArrayBuffer | null): string {
  if (!array) {
    return '';
  }

  const uint8Array = new Uint8Array(array);
  const base64String = arrayBufferToString(uint8Array);

  return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}

export function parseToken(subscription: PushSubscriptionLike): string {
  if (subscription.endpoint.toLowerCase().startsWith('http')) {
    const idMatches = subscription.endpoint.match(/.*\/(.*)/);

    if (!idMatches || !idMatches[1]) {
      throw new Error('SubscriptionId error');
    }

    return idMatches[1];
  }

  return subscription.endpoint;
}

export function describeSubscription(
  subscription: PushSubscriptionLike | Promise<PushSubscriptionLike>
): Promise<PushAPISubscription> {
  if (!(subscription instanceof Promise)) {
    subscription = Promise.resolve(subscription);
  }

  return subscription.then((s) => ({
    token: parseToken(s),
    endpoint: s.endpoint,
    keys: (JSON.parse(JSON.stringify(s)) as PushAPISubscription).keys,
    applicationServerKey: arrayToBase64(s.options?.applicationServerKey),
  }));
}
